<template>
  <div v-loading="loading">
    <div class="box">

      <div class="pagemain">
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="businessdata" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="date" label="時間" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">時間</div>
                {{scope.row.date}}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="操作前進度" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作前進度</div>
                <div style="text-align:left;">
                  <statustextdetail :status="scope.row.status"></statustextdetail>
                </div>
              </template>
            </el-table-column>
						<el-table-column prop="end_status" label="操作後進度" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作後進度</div>
                <div style="text-align:left;">
                  <statustextdetail :status="scope.row.end_status"></statustextdetail>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="action" label="操作" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                {{scope.row.action}}
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作員" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作員</div>
                {{scope.row.operator}}
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="備註" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel" style="flex-shrink: 0;">備註</div>
                <div v-html="scope.row.remarks"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="page-bottom" style="margin-top:15px;" v-if="pager.p_count>10">
        <div>
          Total: {{pager.p_count}}條記錄
        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import statustextdetail from "@/components/StatusTextDetail.vue";
export default {
  components: {
    statustextdetail,
  },
  name: 'BusinessRecords',
  props: ['id'],
  data () {
    return {
      loading: true,
      businessdata: [],
      page:1,
      pagesize:10,
      pager:[],
    };
  },
  methods: {
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    getdata () {
      this.post('/api/business/records', {
        id: this.id,
        page:this.page,
        pagesize:this.pagesize,
      }).then((res) => {
        if (res.status == 'success') {
          this.businessdata = res.data;
          this.pager = res.pager;
          this.page = 1;
        }else{
          this.businessdata = [];
          this.pager = [];
        }
        this.loading = false;
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.getdata();
  }
};
</script>

<style scoped>
</style>
